/* eslint-disable */ 
import React, { useMemo } from 'react';

export const isStaging = false;

const baseUrl = "https://api.voteism.org/user/";
const localUrl = "http://localhost:3001/user/";
const apiUrl = isStaging ? localUrl : baseUrl;

const getResultUrl = apiUrl+"get-live-results";
const getUserLocation = 'https://ipinfo.io/json?token=d862b83e24aef1';
const checkAuthUrl = apiUrl+"check-auth";
const getCoordinates = apiUrl+"get-coordinates/";
const getCountryCoords = apiUrl+"get-coordinates/ALL/MP/";

export const getCoordPoints = (state, isMP, callback) => {
    fetch(getCoordinates+state+(isMP ? '/MP' : '/MLA'), { credentials: 'include' }).then(response => {
        return response.json();
    }).then((res) => {
        console.log('res=',res);
        callback(res);
    }).catch((err) => {
        console.error('Problem checking auth.', err);
        callback(false);
    })
}

export const getCountryCoordPoints = (callback) => {
    fetch(getCountryCoords, { credentials: 'include' }).then(response => {
        return response.json();
    }).then((res) => {
        console.log('res=',res);
        callback(res);
    }).catch((err) => {
        console.error('Problem checking auth.', err);
        callback(false);
    })
}

export const checkAuth = (callback) => {
    fetch(checkAuthUrl, { credentials: 'include' }).then(response => {
        return response.json();
    }).then((res) => {
        // console.log('res=',res);
        callback(res);
    }).catch((err) => {
        console.error('Problem checking auth.', err);
        callback(false);
    })
}

export const getMyLocation = (callback) => {
    fetch(getUserLocation).then(response => {
        return response.json();
    }).then((res) => {
        // console.log('res=',res);
        callback(res);
    }).catch((err) => {
        console.error('Problem fetching my IP', err);
        callback(false);
    })
}

export const fetchResults = (callback) => {
    if(isStaging) {
        const respData = require('./testing/data.json');
        callback(respData);
        return;
    }
    fetch(getResultUrl, { credentials: 'include' })
    .then(response => {
        return response.json()
    })
    .then(data => {
        // console.log('data=',data);
        callback(data);
    }).catch(error => {
        console.log('got error=',error);
        callback(false);
    });
}

export const tableFormat = (plainObject) => {
    let { plainColumns, plainRows, partyLogos } = plainObject;
    let formattedColumns = [], formattedRows = [], partyNames = [];
    for(let i=0;i<plainRows.length;i++) {
        let tempObj = { key: i }, rowData = plainRows[i];
        for(let j=0;j<plainColumns.length;j++) {
            let columnName = plainColumns[j];
            tempObj[columnName] = rowData[j];
            if(j==0) { partyNames.push(rowData[j]); }
        }
        formattedRows.push(tempObj);
    }
    console.log('partyNames=',partyNames);
    for(let i=0, j=0;i<plainColumns.length;i++,j++) {
        let columnName = plainColumns[i];
        let tempObj = { title: columnName, width: 220, dataIndex: columnName, key: columnName,
            align: 'center', sorter: (a, b) => { if(a[columnName]) {
                return a[columnName].localeCompare(b[columnName]);
            } } };
        if(i<2) {
            tempObj['fixed'] = 'left';
            if(i==1) {
                tempObj['sorter'] = (a, b) => a[columnName]-b[columnName];
            }
            if(i==0) {
                tempObj = { ...tempObj,
                render:(_, { Party })=> <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <img src={partyLogos[Party]} width={40} />
                    <div style={{ paddingLeft: 12, fontSize: 18, fontWeight: 'bold', color: '#3a4a5a',
                    alignSelf: 'center' }}>{Party}</div></div> };
            }
        }
        formattedColumns.push(tempObj);
    }
    return { formattedColumns: formattedColumns, formattedRows: formattedRows };
}

export const formatResultsData = (stateResults) => {
    let stateList = [{ name: "India", lName: '' }], stateShorts = ["IN"];
    let resultsMap = {}, partyLogos = {}, updatedTime = '', totalVotes = 0, votesMap = {};
    let leadPartyMap = {}, constiToolTip = {};
    Object.keys(stateResults).map(key => {
        // console.log('key=',key,' stateResults[key]=',stateResults[key]);
        if(key!='leads') {
            let { meta, mp, mla, mlaData, mpData, updatedAt } = stateResults[key];
            stateList.push(meta);
            stateShorts.push(key);
            let plainObjectMLA = parseStateResult(mlaData);
            let stateMLAResult = tableFormat(plainObjectMLA);
            let plainObjectMP = parseStateResult(mpData);
            let stateMPResult = tableFormat(plainObjectMP);
            votesMap[key] = { mla: plainObjectMLA.stateVotes, mp: plainObjectMP.stateVotes };
            totalVotes += plainObjectMP.stateVotes;
            leadPartyMap[key] = { mla: plainObjectMLA.leadPartyInConsti, mp: plainObjectMP.leadPartyInConsti };
            constiToolTip[key] = { mla: plainObjectMLA.stateToolTip, mp: plainObjectMP.stateToolTip }
            console.log('plainObjectMP=',plainObjectMP.partyLogos);
            if(plainObjectMP&&plainObjectMP.partyLogos) {
                partyLogos = { ...partyLogos, ...plainObjectMP.partyLogos };
            }
            if(plainObjectMLA&&plainObjectMLA.partyLogos) {
                partyLogos = { ...partyLogos, ...plainObjectMLA.partyLogos };
            }
            resultsMap[key] = { mla: stateMLAResult, mp: stateMPResult, isMLA: mla, isMP: mp };
            if(updatedAt) {
                updatedTime = updatedAt;
            }
        }
    });
    let indiaLeadsObj = {};
    Object.keys(resultsMap).map(stateName => {
        let stateMPData = resultsMap[stateName].mp;
        let { formattedRows } = stateMPData;
        // console.log('stateName=',stateName,' formattedRows=',formattedRows);
        for(let i=0;i<formattedRows.length;i++) {
            let { Party, Leads } = formattedRows[i];
            // console.log('Party=',Party,' Leads=',Leads,' indiaLeadsObj[Party]=',indiaLeadsObj[Party]);
            indiaLeadsObj[Party] = indiaLeadsObj[Party] ? indiaLeadsObj[Party]+Leads : Leads;
        }
    });
    console.log('indiaLeadsObj=',indiaLeadsObj,' partyLogos=',partyLogos);
    let indiaRows = [];
    let column1 = "Party", column2 = "Leads";
    let tempObj1 = { title: column1, width: 200, dataIndex: column1, key: column1, align: 'center',
        sorter: (a, b) => a[column1].localeCompare(b[column1]) };
    tempObj1 = { ...tempObj1,
    render:(_, { Party })=> <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
        <img src={partyLogos[Party]} width={40} />
        <div style={{ paddingLeft: 12, fontSize: 18, fontWeight: 'bold', color: '#3a4a5a',
        alignSelf: 'center' }}>{Party}</div></div> };
    let tempObj2 = { title: column2, width: 200, dataIndex: column2, key: column2, align: 'center',
        sorter: (a, b) => a[column2]-b[column2] };
    let indiaColumns = [tempObj1, tempObj2];
    Object.keys(indiaLeadsObj).map((partyName, index) => {
        let tempObj = { key: index, Party: partyName, Leads: indiaLeadsObj[partyName] };
        indiaRows.push(tempObj);
    });
    resultsMap["IN"] = { mla: '', mp: { formattedColumns: indiaColumns, formattedRows: indiaRows } };
    votesMap["IN"] = { mla: 0, mp: totalVotes };
    // console.log('votesMap=',votesMap);
    return { stateList, stateShorts, partyLogos, resultsMap, updatedTime, votesMap, leadPartyMap, constiToolTip };
}

const parseStateResult = (stateResult) => {
    let rows = [], columns = ["Party", "Leads"];
    let partyWiseData = {}, partyLogos = {}, leadsCount = {}, stateVotes = 0;
    let leadPartyInConsti = [], stateToolTip = {};
    let stateMpMlaData = stateResult.entityWise;
    let statePartydata = stateResult.partyWise;
    Object.keys(statePartydata).map(key => {
        // console.log('party Logo=',statePartydata[key]);
        partyLogos[key] = statePartydata[key].logo;
    });
    partyLogos['Group - A'] = require('./assets/groupA.png');
    partyLogos['Group - B'] = require('./assets/groupB.png');
    let sortedKeys = Object.keys(stateMpMlaData).sort();
    console.log('sortedKeys=',sortedKeys);
    sortedKeys.map(constiName => {
        // console.log('constiName=', constiName);
        columns.push(constiName);
        let constiData = stateMpMlaData[constiName];
        let maxVotes = 0, partyName = '', toolTipMsg = '';
        let sortedParties = Object.keys(constiData).sort();
        sortedParties.map(partyKey => {
            // console.log('partyKey=', partyKey);
            let { voteCount, votePercentage } = constiData[partyKey];
            let voteDetails = voteCount+'\n('+votePercentage+'%)';
            toolTipMsg += (partyKey+': '+voteCount+'<br />');
            if(partyWiseData[partyKey]) {
                partyWiseData[partyKey] = [ ...partyWiseData[partyKey], voteDetails ];
            } else {
                partyWiseData[partyKey] = [ 0, voteDetails ];
            }
            if(maxVotes<voteCount) {
                maxVotes = voteCount, partyName = partyKey;
            }
            stateVotes += voteCount;
        });
        stateToolTip[constiName] = toolTipMsg;
        leadPartyInConsti.push({ name: constiName, value: partyIndexes[partyName] });
        leadsCount[partyName] = leadsCount[partyName] ? leadsCount[partyName]+1 : 1;
    });
    console.log('leadsCount=',leadsCount);
    // console.log('columns=', columns);
    console.log('partyWiseData=', partyWiseData);
    sortedKeys = Object.keys(partyWiseData).sort();
    sortedKeys.map(partyName => {
        let singleRow = [partyName];
        let singlePartyData = partyWiseData[partyName];
        console.log(partyName,' partyWiseData=',singlePartyData);
        if(leadsCount[partyName]) {
            singlePartyData[0] = leadsCount[partyName];
        }
        for(let i=0;i<singlePartyData.length;i++) {
            singleRow.push(singlePartyData[i]);
        }
        rows.push(singleRow);
    });
    // console.log('rows=', rows);
    return { plainColumns: columns, plainRows: rows, partyLogos, stateVotes, leadPartyInConsti, stateToolTip };
}

export const parseStateResultGroups = (stateResult, group1List, group2List) => {
    if(!(stateResult&&stateResult.entityWise)) {
        return { leadData: {}, stateToolTip: {} };
    }
    let partyWiseData = {};
    let leadPartyInConsti = [], stateToolTip = {};
    let stateMpMlaData = stateResult.entityWise;
    console.log('stateMpMlaData=',stateMpMlaData);
    let sortedKeys = Object.keys(stateMpMlaData).sort();
    console.log('sortedKeys result groups=',sortedKeys);
    sortedKeys.map(constiName => {
        // console.log('constiName=', constiName);
        let constiData = stateMpMlaData[constiName];
        let maxVotes = 0, partyName = '', toolTipMsg = '', sortable = [], group1Count = 0, group2Count = 0;
        let sortedParties = Object.keys(constiData).sort();
        sortedParties.map(partyKey => {
            // console.log('partyKey=', partyKey);
            let { voteCount, votePercentage } = constiData[partyKey];
            let voteDetails = voteCount+'\n('+votePercentage+'%)';
            // toolTipMsg += (partyKey+': '+voteCount+'<br />');
            if(partyWiseData[partyKey]) {
                partyWiseData[partyKey] = [ ...partyWiseData[partyKey], voteDetails ];
            } else {
                partyWiseData[partyKey] = [ 0, voteDetails ];
            }
            if(maxVotes<voteCount) {
                maxVotes = voteCount, partyName = partyKey;
            }
            let found2 = group2List.some(el => el.partyId === partyKey);
            if(found2) {
                group2Count+= voteCount;
                if(group2Count>=maxVotes) {
                    partyName = 'GROUP2';
                    maxVotes = group2Count;
                }
            }
            let found1 = group1List.some(el => el.partyId === partyKey);
            if(found1) {
                group1Count+= voteCount;
                if(group1Count>=maxVotes) {
                    partyName = 'GROUP1';
                    maxVotes = group1Count;
                }
            }
            sortable.push([partyKey, voteCount]);
        });
        sortable.push(['GroupA', group1Count]);
        sortable.push(['GroupB', group2Count]);
        sortable.sort(function(a, b) {
            return b[1] - a[1];
        });
        console.log('sortable=',sortable);
        for(let i=0;i<sortable.length;i++) {
            let currentObj = sortable[i];
            if(currentObj[0]!='ac_name'&&currentObj[0]!='pc_name') {
                toolTipMsg += (currentObj[0]+': '+currentObj[1]+'<br />');
            }
        }
        console.log('toolTipMsg=',toolTipMsg);
        stateToolTip[constiName] = toolTipMsg;
        leadPartyInConsti.push({ name: constiName, value: partyIndexes[partyName] });
    });
    return { leadData: leadPartyInConsti, stateToolTip: stateToolTip };
}

export const MemoImage = (partyLogo, partyId) => {
    const childImage = useMemo(() => <img src={partyLogo} width={'72px'} alt={partyId} />, [partyId]);
    return childImage;
}

export const partyColors = {
    "AAP": "#0f93d4",
    "AD(S)": "#26166d",
    "AGP": "#a2080a",
    "AIADMK": "#0b9421",
    "AIMIM": "#146b4b",
    "AINRC": "#f9da02",
    "AITC": "#20c646",
    "AIUDF": "#348a4d",
    "AJSU": "#4d3883",
    "AMMK": "#034f38",
    "BDF": "#ff6600",
    "BJD": "#2ea446",
    "BJP": "#f47216",
    "BRS": "#ff069b",
    "BSP": "#1c3e9b",
    "BTP": "#ff0000",
    "BVA": "#fff100",
    "C(S)": "#0b8802",
    "CPI": "#e70d21",
    "CPI(ML)L": "#c41301",
    "CPM": "#ff1d15",
    "DMDK": "#ffea19",
    "DMK": "#f30000",
    "GFP": "#3c4092",
    "HAM": "#ff0000",
    "HSPDP": "#0a01ae",
    "INC": "#5096ff",
    "INLD": "#2f6600",
    "IPFT": "#118000",
    "IUML": "#116600",
    "JCC": "#ffc0db",
    "JD(L)": "#ffff00",
    "JD(S)": "#02865a",
    "JD(U)": "#108000",
    "JJP": "#fef282",
    "JMM": "#337316",
    "JSP": "#fb0000",
    "KC": "#df0000",
    "KC(M)": "#df0000",
    "KHNAM": "#ff0050",
    "KPA": "#607090",
    "KRPP": "#3886c4",
    "LSP": "#00a54e",
    "MDMK": "#fc0000",
    "MGP": "#d06433",
    "MNF": "#2ba5f7",
    "MNM": "#ce0505",
    "MNS": "#612404",
    "NCP": "#128408",
    "NDPP": "#e51922",
    "NOTA": "#333333",
    "NPF": "#003f66",
    "NPP": "#256898",
    "NSC": "#fe0201",
    "NTK": "#d31e27",
    "PDF": "#e8d463",
    "PJP": "#0105a4",
    "PMK": "#edf700",
    "PSP": "#f4c412",
    "RD": "#fee502",
    "RGP": "#ddaa61",
    "RJD": "#007c00",
    "RLD": "#0a8201",
    "RLP": "#88b946",
    "RSP": "#f50117",
    "SAD": "#f69331",
    "SAD(A)": "#362d85",
    "SBSP": "#f0d467",
    "SDF": "#f7f406",
    "SHS": "#e97222",
    "SKM": "#f50002",
    "SP": "#108237",
    "SS (UBT)": "#f1771e",
    "TDP": "#eaba04",
    "TIPRA": "#f60000",
    "UDP": "#f50005",
    "UKD": "#00541c",
    "UPPL": "#19ad3f",
    "VCK": "#007cf7",
    "YSRCP": "#233d8a",
    "YSRTP": "#00BACF",
    "ZPM": "#f7e803",
    "JBNP": "#2a5335",
    "GROUP1": "#7BACF5",
    "GROUP2": "#EE3D63",
};

{/*
export const partyArray = ["AAP","AD(S)","AGP","AIADMK","AIMIM","AINRC","AITC","AIUDF","AJSU","AMMK",
"BDF","BJD","BJP","BRS","BSP","BTP","BVA","C(S)","CPI","CPI(ML)L","CPM","DMDK","DMK","GFP","HAM",
"HSPDP","INC","INLD","IPFT","IUML","JCC","JD(L)","JD(S)","JD(U)","JJP","JMM","JSP","KC","KC(M)","KHNAM",
"KPA","KRPP","LSP","MDMK","MGP","MNF","MNM","MNS","NCP","NDPP","NOTA","NPF","NPP","NSC","NTK","PDF","PJP",
"PMK","PSP","RD","RGP","RJD","RLD","RLP","RSP","SAD","SAD(A)","SBSP","SDF","SHS","SKM","SP","SS (UBT)",
"TDP","TIPRA","UDP","UKD","UPPL","VCK","YSRCP","YSRTP","ZPM","JBNP","GROUP1","GROUP2"];
*/}

export const partyColorsArray = ["#0f93d4","#26166d","#a2080a","#0b9421","#146b4b","#f9da02","#20c646",
"#348a4d","#4d3883","#034f38","#ff6600","#2ea446","#f47216","#ff069b","#1c3e9b","#ff0000","#fff100",
"#0b8802","#e70d21","#c41301","#ff1d15","#ffea19","#f30000","#3c4092","#ff0000","#0a01ae","#5096ff",
"#2f6600","#118000","#116600","#ffc0db","#ffff00","#02865a","#108000","#fef282","#337316","#fb0000",
"#df0000","#df0000","#ff0050","#607090","#3886c4","#00a54e","#fc0000","#d06433","#2ba5f7","#ce0505",
"#612404","#128408","#e51922","#333333","#003f66","#256898","#fe0201","#d31e27","#e8d463","#0105a4",
"#edf700","#f4c412","#fee502","#ddaa61","#007c00","#0a8201","#88b946","#f50117","#f69331","#362d85",
"#f0d467","#f7f406","#e97222","#f50002","#108237","#f1771e","#eaba04","#f60000","#f50005","#00541c",
"#19ad3f","#007cf7","#233d8a","#00BACF","#f7e803","#2a5335","#7BACF5","#EE3D63"];

export const partyIndexes = {"AAP":1,"AD(S)":2,"AGP":3,"AIADMK":4,"AIMIM":5,"AINRC":6,"AITC":7,"AIUDF":8,
"AJSU":9,"AMMK":10,"BDF":11,"BJD":12,"BJP":13,"BRS":14,"BSP":15,"BTP":16,"BVA":17,"C(S)":18,"CPI":19,
"CPI(ML)L":20,"CPM":21,"DMDK":22,"DMK":23,"GFP":24,"HAM":25,"HSPDP":26,"INC":27,"INLD":28,"IPFT":29,
"IUML":30,"JCC":31,"JD(L)":32,"JD(S)":33,"JD(U)":34,"JJP":35,"JMM":36,"JSP":37,"KC":38,"KC(M)":39,
"KHNAM":40,"KPA":41,"KRPP":42,"LSP":43,"MDMK":44,"MGP":45,"MNF":46,"MNM":47,"MNS":48,"NCP":49,"NDPP":50,
"NOTA":51,"NPF":52,"NPP":53,"NSC":54,"NTK":55,"PDF":56,"PJP":57,"PMK":58,"PSP":59,"RD":60,"RGP":61,
"RJD":62,"RLD":63,"RLP":64,"RSP":65,"SAD":66,"SAD(A)":67,"SBSP":68,"SDF":69,"SHS":70,"SKM":71,"SP":72,
"SS (UBT)":73,"TDP":74,"TIPRA":75,"UDP":76,"UKD":77,"UPPL":78,"VCK":79,"YSRCP":80,"YSRTP":81,"ZPM":82,
"JBNP":83,"GROUP1":84,"GROUP2":85};
